import HealthcareProfessionalInformationGuide from "./../../src/components/pages/PatientMaterial/Brochures/PDFs/HealthcareProfessionalInformationGuide.pdf";

const hcpBrochure =
  process.env.NODE_ENV === "production"
    ? "https://psh-ie-files-live.s3.amazonaws.com/Healthcare_Professional_Information_Guide.pdf"
    : HealthcareProfessionalInformationGuide;

export const errorMessages = {
  PASSWORD_LINK_INVALID: "Password Reset Link is Invalid",
  PASSWORD_LINK_INVALID_DESCRIPTION:
    "Please click/copy the link again to reset your password.",
  INVALID_EMAIL: "Email is invalid",
  INVALID_PASSWORD: "Password is invalid",
  PASSWORD_LENGTH: "Password length must be between 8 and 20 characters",
  PASSWORD_CHARACTERS:
    "Password must contain at least one capital letter, one number and one special character",
  PASSWORD_MATCH: "Passwords must match",
  PATIENT_NOT_AGREED_REQUIRMENTS:
    "Patient has not agreed to the required statements",
  PATIENT_NOT_AGREED_REQUIRMENTS_DESCRIPTION:
    "The patient has not agreed to 1 or more statements on this page. please tick the boxes and confirm that the patient has agreed before continuing.",
  PRESCRIBER_NOT_AGREED_REQUIRMENTS:
    "Prescribing Physician has not agreed to the required statements",
  PRESCRIBER_NOT_AGREED_REQUIRMENTS_DESCRIPTION:
    "The prescribing physician has not agreed to 1 or more statements on this page. Please tick the boxes and confirm that the patient has agreed before continuing.",
  PHARMACY_NOT_AGREED_REQUIRMENTS:
    "Chief/ Superintendant Pharmacist (or appointed Deputy) has not agreed to the required statements.",
  PHARMACY_NOT_AGREED_REQUIRMENTS_DESCRIPTION:
    "1 or more statements on this page have not been confirmed. Please tick the appropriate box(es) to complete the registration process.",
  NEED_VALID_NEGATIVE_TEST: `<div>A valid negative pregnancy test must have been conducted a maximum of 3 days prior to the prescription date. Please refer to the SmPC or <a
    rel="noreferrer"
    href=${hcpBrochure}
    target="_blank"
  >
    Lenalidomide Healthcare Professional Brochure
  </a> for further information on pregnancy prevention measures</div>`,
  OUTDATED_PREGANACY_TEST_TITLE:
    "Pregnancy test date outside permitted date range",
  SOMETHING_WENT_WRONG: "Something went wrong",
  PRESCRIBER_NURSE_NOT_AGREED_REQUIRMENTS:
    "Prescribing Nurse has not agreed to the required statements",
  PRESCRIBER_NURSE_NOT_AGREED_REQUIRMENTS_DESCRIPTION:
    "The prescribing nurse has not agreed to 1 or more statements on this page. Please tick the boxes and confirm that the patient has agreed before continuing.",
  PRESCRIBER_PHARMACIST_NOT_AGREED_REQUIRMENTS:
    "Prescribing Pharmacist has not agreed to the required statements",
  PRESCRIBER_PHARMACIST_NOT_AGREED_REQUIRMENTS_DESCRIPTION:
    "The prescribing pharmacist has not agreed to 1 or more statements on this page. Please tick the boxes and confirm that the patient has agreed before continuing.",
  PASSWORD_NOT_MATCH: "Password does not match",
  MUST_CLICK_LINK_TITLE: "Information Guide not read",
  MUST_CLICK_LINK_DESCRIPTION:
    "Please select and read the Lenalidomide Healthcare Professional Information Guide before continuing with the following responsibilities.",
  CONFIRMATION_NOT_PROVIDED_TITLE: "Confirmation not provided",
  CONFIRMATION_NOT_PROVIDED_DESCRIPTION: `<div>Please check the confirmation box that the patient has been counselled on the terms of the Pregnancy Prevention Programme. Please refer to the SmPC and <a
rel="noreferrer"
href=${hcpBrochure}
target="_blank"
>
Lenalidomide Healthcare Professional Brochure
</a> for further information on pregnancy prevention measures.</div>`,
INTERNAL_SERVER_ERROR: "Internal Server Error"
};
